import logo from "./logo.svg";
import "./App.css";
import Home from "./components/home";
import Login from "./components/login/login";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { JTCookies } from "./utils/storage/cookies";
import { QueryClient, QueryClientProvider } from "react-query";
import { isAfter } from "date-fns";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 1000 * 60 * 10, // Data is considered fresh for 10 minutes
      cacheTime: 1000 * 60 * 15, // Data is kept in cache for 15 minutes
      refetchOnMount: false, // Do not refetch on component mount
      refetchOnWindowFocus: false, // Do not refetch on window focus
    },
  },
});

function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ck = new JTCookies(document);
    (async () => {
      try {
        const expDate = await ck.getCookie("expiryDate");
        const authAdToken = await ck.getCookie("authAdToken");
        console.log({ expDate, authAdToken });
        if (!expDate || !authAdToken) {
          return setLoading(false);
        } else {
          const aft = isAfter(new Date(expDate), new Date());
          if (!aft) return setLoading(false);
          setLoading(false);
          setLoggedIn(true);
        }
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return <></>;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <div className="App">
        <ToastContainer />
        {loggedIn ? <Home /> : <Login />}
      </div>
    </QueryClientProvider>
  );
}

export default App;
